import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const departmentApiUrl = `${baseApiUrl}/api/Departments/GetDepartmentsList`;
const primaveraDepartmentApiUrl = `${baseApiUrl}/api/Departments/GetPrimaveraDepartmentsList`;

export async function getDepartments() {
    return await httpRequest(fetchDepartments.bind(this));
}

async function fetchDepartments() {
    let config = getHttpHeaders();
    return await axios.get(`${departmentApiUrl}`, config);
}

export async function getPrimaveraDepartments() {
    return await httpRequest(fetchPrimaveraDepartments.bind(this));
}

async function fetchPrimaveraDepartments() {
    let config = getHttpHeaders();
    return await axios.get(`${primaveraDepartmentApiUrl}`, config);
}